import React from "react";
import bannerImg from "../../assets/ingridients-images/madhumeh/intake-madhu.png";

const ConsumeBanner = () => {
  return (
    <section className="consume-bannerr">
      {/* <h2>How To Consume Powder</h2> */}
      <img src={bannerImg} alt="How To Consume Powder Banner" />
    </section>
  );
};

export default ConsumeBanner;
